const rateFormat = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 2 });

export const maxRate = 9999999999.99;

export const formatRate = (value) => rateFormat.format(value);

export const formatRateRange = ({ min, max }) =>
  min === max ? formatRate(min) : `${formatRate(min)}–${formatRate(max)}`;

export const findCell = (cells, roleId, levelId) =>
  cells.find(({ role_id, level_id }) => role_id === roleId && level_id === levelId);

export const rateStats = (values) => {
  const sorted = [...values].sort((a, b) => a - b);
  const middle = Math.floor(sorted.length / 2);
  return {
    min: sorted[0],
    max: sorted[sorted.length - 1],
    average: sorted.reduce((sum, value) => sum + value, 0) / sorted.length,
    median: sorted.length % 2 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2,
  };
};

const niceStep = (span, count) => {
  const raw = span / count;
  const magnitude = 10 ** Math.floor(Math.log10(raw));
  const fraction = raw / magnitude;
  return (fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10) * magnitude;
};

const niceTicks = (to, count) => {
  const step = niceStep(to, count);
  return Array.from({ length: Math.ceil(to / step - 1e-9) + 1 }, (_, index) => index * step);
};

export const rateCurve = (values, points = 160) => {
  const n = values.length;
  const logs = values.map((value) => Math.log(Math.max(value, 1)));
  const mu = logs.reduce((sum, value) => sum + value, 0) / n;
  const sigma = Math.max(
    Math.sqrt(logs.reduce((sum, value) => sum + (value - mu) ** 2, 0) / n),
    0.05
  );
  const low = Math.min(Math.exp(mu - 3.5 * sigma), Math.min(...values));
  const maxValue = Math.max(...values);
  const high = Math.min(Math.max(Math.exp(mu + 2.5 * sigma), maxValue), maxValue * 1.5);
  const step = niceStep(high - low, 6);
  const start = Math.floor(low / step) * step;
  const from = start < 2 * step ? 0 : start;
  const to = Math.ceil(high / step) * step;
  const ticks = Array.from(
    { length: Math.round((to - from) / step) + 1 },
    (_, index) => from + index * step
  );

  const curve = Array.from({ length: points }, (_, index) => {
    const rate = from + ((to - from) * index) / (points - 1);
    const density =
      rate > 0
        ? (n * step * Math.exp(-0.5 * ((Math.log(rate) - mu) / sigma) ** 2)) /
          (rate * sigma * Math.sqrt(2 * Math.PI))
        : 0;
    return { rate, density };
  });
  const peak = Math.max(...curve.map(({ density }) => density));
  return { curve, ticks, densityTicks: niceTicks(peak, 4) };
};
